<template>
    <div id="list-reporting-filter" class="modal inmodal fade" role="dialog" :aria-hidden="!visible" data-backdrop="static"
         tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header modal-header-dialog-painting text-left" ref="header">
                    <h2 class="modal-title" v-if="mode === 'add'">{{ t_new_filter_title }}</h2>
                    <h2 class="modal-title" v-if="mode === 'edit'">{{ t_edit_filter_title }}</h2>
                </div>
                <div class="modal-body">
                    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger modal-errors">
                        {{ t_save_error }}
                        <ul>
                            <li v-for="error in errors">
                                {{error}}
                            </li>
                        </ul>
                    </div>
                    <form class="list-reporting-filter" role="form">
                        <div class="row modal-fixed-row mb-3">
                            <div class="col-md-6">
                                <div v-bind:class="[(typeof errors.name !== 'undefined' ? 'has-error':''),'form-group']">
                                    <label>{{ t_name }}:</label>
                                    <input type="text" ref="filtername" class="form-control" v-model="name">
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <div class="scrollBox" :style="'max-height: ' + maxInnerHeight + 'px;'">
                                <div class="row m-l-none m-r-none" v-for="filters in chunkedFilters">
                                    <div class="col-lg-6" v-for="element in filters">
                                        <text255 v-if="element.type === 'text255'"
                                                 :name="element.name"
                                                 :id="element.id"
                                                 v-model="element.value">
                                        </text255>
                                        <bool v-if="element.type === 'bool'"
                                              :name="element.name"
                                              :id="element.id"
                                              v-model="element.value">
                                        </bool>
                                        <float v-if="element.type === 'float'"
                                               :name="element.name"
                                               :id="element.id"
                                               v-model="element.value">
                                        </float>
                                        <date v-if="element.type === 'date'"
                                              :name="element.name"
                                              :id="element.id"
                                              v-model="element.value"
                                              :has_error="(typeof errors[element.id] !== 'undefined' ? '1':'0')">
                                        </date>
                                        <multiselect v-if="element.type === 'multiselect'"
                                                     :name="element.name"
                                                     :id="element.id"
                                                     v-model="element.value">
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" class="btn btn-primary submit" @click.stop.prevent="update"
                            v-if="mode === 'add'">
                        <i v-if="saving === true" class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
                        {{ t_add }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-primary submit" @click.stop.prevent="update"
                            v-if="mode === 'edit'">
                        <i v-if="saving === true" class="fa-regular fa-spinner fa-spin-pulse m-r-xs"></i>
                        {{ t_edit }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-danger pull-left" @click.stop.prevent="remove"
                            v-if="mode === 'edit'">
                        <i class="fa-regular fa-spinner fa-spin-pulse m-r-sm" :class="[deleting === true ? '' : 'hidden']"></i>{{ t_delete }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-white" data-dismiss="modal">{{ t_cancel }}</v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../common/modal-mixin"
    import draggable from 'vuedraggable';
    import toaster from "../common/toaster";

    export default {
        mixins: [
            modalMixin,
        ],
        components: {
            draggable,
            text255: require('./dynamic_fields/text255.vue').default,
            multiselect: require('./dynamic_fields/multiselect.vue').default,
            bool: require('./dynamic_fields/bool.vue').default,
            float: require('./dynamic_fields/float.vue').default,
            date: require('./dynamic_fields/date.vue').default
        },
        data: function () {
            return {
                t_close: Lang.langGet("Close"),
                t_new_filter_title: Lang.langGet("Add New Filter"),
                t_cancel: Lang.langGet("Cancel"),
                t_edit: Lang.langGet("Update"),
                t_add: Lang.langGet("Add"),
                t_delete: Lang.langGet("Delete"),
                t_load_error: Lang.langGet("Failed to load filter data."),
                t_save_success: Lang.langGet("Filter successfully saved."),
                t_save_error: Lang.langGet("Failed to save filter."),
                t_delete_success: Lang.langGet("Filter successfully deleted."),
                t_delete_error: Lang.langGet("Failed to delete Filter."),
                t_name: Lang.langGet("Filter Name"),
                t_yes: Lang.langGet("Yes"),
                t_no: Lang.langGet("No"),
                mode: 'add',
                name: '',
                filters: [],
                filter_id: -1,
                errors: {},
                deleting: false,
                saving: false,
                modalName: 'list-reporting-filter',
            }
        },
        computed: {
            t_edit_filter_title: function () {
                return Lang.langGet("Edit Filter \":name\"", {name: this.name});
            },
            chunkedFilters: function () {
                return _.chunk(this.filters, 2);
            },
            headerHeight: function () {
                return this.$refs.header ? this.$refs.header.clientHeight : 0;
            },
        },
        methods: {
            update: function () {
                if(this.saving === true) {
                    return;
                }

                this.saving = true;

                axios.post('/system/reporting/list-update-filter', {
                    filters: this.filters,
                    filter_id: this.filter_id,
                    name: this.name,
                    project_id: Laravel.activeProject
                }).then(() => {
                    this.saving = false;
                    toaster.success(this.t_save_success);
                    EaseEventBus.fire('hideModal', 'list-reporting-filter');
                    EaseEventBus.fire('updateExistingFilters');
                    //workaround to not start a rewrite in the old codebase
                    EaseEventBus.listen('loadedReportFilter', () => {
                        EaseEventBus.fire('setNewReportFilterAsCurrent', {name: this.name});
                    })
                }).catch((error) => {
                    this.saving = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    } else if (error.response.status === 422) {
                        let tmpErrors = {};

                        for (let key in error.response.data.errors) {
                            tmpErrors[key] = error.response.data.errors[key][0];
                        }

                        this.errors = _.extend({}, {}, tmpErrors);
                    } else {
                        toaster.error(this.t_save_error);
                    }
                    this.$nextTick(() => {
                        this.calcModalHeight();
                    });
                });
            },
            remove: function () {
                if(this.deleting === true) {
                    return;
                }

                this.deleting = true;

                axios.post('/system/reporting/list-delete-filter', {
                    project_id: Laravel.activeProject,
                    filter_id: this.filter_id
                }).then(() => {
                    this.deleting = false;
                    EaseEventBus.fire('updateExistingFilters');
                    EaseEventBus.fire('hideModal', 'list-reporting-filter');
                    EaseEventBus.fire('setNewReportFilterAsCurrent', {name: 'Select a filter...'});
                    toaster.success(this.t_delete_success);
                }).catch((error) => {
                    this.deleting = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_delete_error);
                });
            },
            load: function () {
                axios.post('/system/reporting/list-data-filter', {
                    project_id: Laravel.activeProject,
                    filter_id: this.filter_id
                }).then((response) => {
                    this.filters = response.data.data.filter;
                    EaseEventBus.fire('showModal', 'list-reporting-filter');
                    if(this.mode === 'add') {
                        this.$nextTick(function () {
                            this.$refs.filtername.focus();
                        });
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_error);
                });
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            }
        },
        mounted() {
            EaseEventBus.listen('showEditDeleteFilterModal', (data) => {
                this.reset();
                this.name = data.name;
                this.filter_id = data.id;
                this.mode = 'edit';
                this.load();
            });

            EaseEventBus.listen('showNewFilterModal', () => {
                this.reset();
                this.mode = 'add';
                this.load();
            });
        }
    }
</script>
